export default (str: string) => {
  return(encodeURIComponent(str).replace(/%../g,"x").length);
};